import React from 'react'

export default function Loading() {
    return (
        <div className=" flex justify-center items-center">
            <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary100 "></div>
        </div>
    )
}
